export default __webpack_public_path__ + "static/media/vgs.c1e9240f.png";